//
//
//
//
//
//
//
//
//

export default {
    props: {
        persistent: {
            type: Boolean,
            default: false,
        },
        /** @type {import('vue').PropOptions<TIDAL.UserInfo>} */
        userInfo: {
            type: Object,
            required: true,
        },
    },
    methods: {
        async reverify() {
            const token = await this.$tidalAuth.fetchAccessToken();
            window.open(`${process.env.OFFER_ORIGIN}/student?token=${token}&lang=${this.$i18n.localeProperties.lang}`);
        },
    },
};
